import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class depotSelectListCtrl implements IController {
  options: any;
  selectedId: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  branchIds: string[];
  accountIds: string[];
  onChange: Function;


  private depotsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public excludedMap: any;

  /* @ngInject */
  constructor(private $depots, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.depotsRef = this.$depots();
    if (!this.options) {
      this.loadLimit = 20;
      this.depotsRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.depotsRef, this.loadLimit, {getFullData: true});
    } else {
      this.loadLimit = 0;
      this.infiniteScroll = this.$infiniteScroll(this.depotsRef, this.loadLimit, {ignoreFetch: true});
      this.infiniteScroll.addItems(this.options);
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.depotsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      ids: this.optionIds,
      branchIds: this.branchIds,
      accountIds: this.accountIds,
      limit:  this.loadLimit,
      query:  this.queryString,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.depots')
  .component('depotSelectList', {
    bindings: {
      options: '<?',
      optionIds: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      branchIds: '<?',
      accountIds: '<?',
      onChange: '&'
    },
    template: require('./depot-select-list.html').default,
    controller: depotSelectListCtrl
  });
